// Route: /cfm/feedback-request/edit/:publicCode
import React from "react";
import FeedbackRequestSetup from "./FeedbackRequestSetup";

export default function EditFeedbackRequest() {
    return <FeedbackRequestSetup mode="edit" />;
}